// src/frontend_react/src/pages/UserDashboard/JobDetailPane.js
import React from 'react';
import { NavLink, Outlet, useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import * as api from '../../services/api';

// UI Components
import Box from '../../components/ui/Box/Box';
import Spinner from '../../components/ui/Spinner/Spinner';
import Alert from '../../components/ui/Alert/Alert';
import Typography from '../../components/ui/Typography/Typography';
import styles from './JobDetailPane.module.css';

const JobDetailPane = () => { // No longer needs a 'job' prop
  const { batchId } = useParams();

  // NEW: Fetch the full details for this specific job.
  const { data: job, isLoading, error } = useQuery({
    queryKey: ['jobDetails', batchId], // A unique key for this job's data
    queryFn: () => api.getBatchDetails(batchId),
    enabled: !!batchId, // Only run the query if there is a batchId
    refetchInterval: (query) => {
      // The data is in query.state.data, not query.data in this callback
      const status = query.state.data?.status;
      // Poll every 5 seconds if the job is in a processing or just finalized state
      return (status === 'processing' || status === 'finalized') ? 5000 : false;
    },
  });

  if (isLoading) {
    return (
      <Box p="lg" display="flex" justifyContent="center">
        <Spinner />
        <Typography ml={2} color="secondary">Loading Job Details...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box p="lg">
        <Alert variant="error" title="Could not load job details">
          {error.message}
        </Alert>
      </Box>
    );
  }
  
  // Define tabs available for this job
  const tabs = [
    { id: 'overview', label: 'Overview' },
    { id: 'run', label: 'Run Reconciliation' },
    { id: 'results', label: 'Results' },
  ];

  return (
    <Box className={styles.detailPane}>
      <nav className={styles.tabNav}>
        {tabs.map((tab) => (
          <NavLink
            key={tab.id}
            to={`/user/workspace/${batchId}/${tab.id}`}
            className={({ isActive }) =>
              `${styles.tabLink} ${isActive ? styles.active : ''}`
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>
      <Box className={styles.tabContent}>
        <Outlet context={{ job }} /> 
      </Box>
    </Box>
  );
};

export default JobDetailPane;